import { studioApiSdk } from '@/lib/fetcher'
import { CreateTemplateRoute, RouteTemplate, RouteTemplateFilterData, GetTemplate } from '@/features/templates'

export const getRouteTemplates = async (filter?: RouteTemplateFilterData): Promise<RouteTemplate[]> => {
  return studioApiSdk.getRouteTemplates(filter)
}

export const getRouteTemplate = async (templateId: number): Promise<GetTemplate> => {
  return studioApiSdk.getRouteTemplate(templateId)
}

export const createRouteTemplate = async (
  template: CreateTemplateRoute,
  code?: string | null
): Promise<RouteTemplate> => {
  return studioApiSdk.createRouteTemplate(template, code || null)
}

export const updateRouteTemplate = async (
  templateId: number,
  template: Partial<RouteTemplate>,
  code?: string | null
): Promise<RouteTemplate> => {
  // @ts-expect-error partial is fine here
  return studioApiSdk.updateRouteTemplate(templateId, template, code)
}

export const deleteRouteTemplate = async (templateId: number): Promise<void> => {
  return studioApiSdk.deleteRouteTemplate(templateId)
}
